import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { SwiperOptions } from 'swiper/types'
@Component({
  selector: 'flowaccount-starter-kit-shared',
  templateUrl: './starter-kit-shared.component.html',
  styleUrls: ['./starter-kit-shared.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StarterKitSharedComponent implements OnInit {
  private myForm: FormGroup
  public bookSelected
  public config: SwiperOptions
  @Input() styleClass: string
  public starterKitList = [
    {
      bookImage: 'https://flowaccountcdn.com/new_landing/image/starter-kit/Starter-Kit-Cover-4.png',
      bookImageWebP: 'https://flowaccountcdn.com/new_landing/image/starter-kit/Starter-Kit-Cover-4.webp',
      bookTitle: 'STARTER_KIT_SHARED.1.BOOKTITLE',
      bookDetail: 'STARTER_KIT_SHARED.1.BOOKDETAIL',
      bookPdfLink: '',
      bookPdfLinkFree: 'https://flowaccountcdn.com/new_landing/document-pdf/starter-kit/1_Compliance.pdf',
    },
    {
      bookImage: 'https://flowaccountcdn.com/new_landing/image/starter-kit/Starter-Kit-Cover-3.png',
      bookImageWebP: 'https://flowaccountcdn.com/new_landing/image/starter-kit/Starter-Kit-Cover-3.webp',
      bookTitle: 'STARTER_KIT_SHARED.2.BOOKTITLE',
      bookDetail: 'STARTER_KIT_SHARED.2.BOOKDETAIL',
      bookPdfLink: '',
      bookPdfLinkFree: 'https://flowaccountcdn.com/new_landing/document-pdf/starter-kit/2_Selling.pdf',
    },
    {
      bookImage: 'https://flowaccountcdn.com/new_landing/image/starter-kit/Starter-Kit-Cover-2.png',
      bookImageWebP: 'https://flowaccountcdn.com/new_landing/image/starter-kit/Starter-Kit-Cover-2.webp',
      bookTitle: 'STARTER_KIT_SHARED.3.BOOKTITLE',
      bookDetail: 'STARTER_KIT_SHARED.3.BOOKDETAIL',
      bookPdfLink: 'https://flowaccountcdn.com/new_landing/document-pdf/starter-kit/3_Service.pdf',
      bookPdfLinkFree: '',
    },
    {
      bookImage: 'https://flowaccountcdn.com/new_landing/image/starter-kit/Starter-Kit-Cover-5.png',
      bookImageWebP: 'https://flowaccountcdn.com/new_landing/image/starter-kit/Starter-Kit-Cover-5.webp',
      bookTitle: 'STARTER_KIT_SHARED.4.BOOKTITLE',
      bookDetail: 'STARTER_KIT_SHARED.4.BOOKDETAIL',
      bookPdfLink: 'https://flowaccountcdn.com/new_landing/document-pdf/starter-kit/4_Performance%20business.pdf',
      bookPdfLinkFree: '',
    },
    {
      bookImage: 'https://flowaccountcdn.com/new_landing/image/starter-kit/Starter-Kit-Cover-1.png',
      bookImageWebP: 'https://flowaccountcdn.com/new_landing/image/starter-kit/Starter-Kit-Cover-1.webp',
      bookTitle: 'STARTER_KIT_SHARED.5.BOOKTITLE',
      bookDetail: 'STARTER_KIT_SHARED.5.BOOKDETAIL',
      bookPdfLink: 'https://flowaccountcdn.com/new_landing/document-pdf/starter-kit/5_Set%20up%20FlowAccount.pdf',
      bookPdfLinkFree: '',
    },
  ]

  constructor(private fb: FormBuilder, public translate: TranslateService) {
    this.myForm = this.fb.group({
      supportCode: ['', [Validators.required, Validators.pattern(/N\d{6}/)]],
    })
  }
  ngOnInit(): void {
    this.swiperConfig()
  }
  save(url: string) {
    const aTag = document.createElement('a')
    aTag.href = url
    aTag.rel = 'noopener'
    aTag.target = '_blank'
    aTag.download = url.split('/').pop()
    document.body.appendChild(aTag)
    aTag.click()
    document.body.removeChild(aTag)
  }
  onChildEvent($event: object) {
    this.bookSelected = $event
    setTimeout(() => {
      this.scrollToElement('scrollToElement', 20)
    }, 500)
  }
  scrollToElement(elementId: string, paddingTop: number) {
    setTimeout(() => {
      const element = document.getElementById(elementId)
      if (element) {
        const offsetTop = element.offsetTop - paddingTop
        window.scrollTo({ top: offsetTop, behavior: 'smooth' })
      }
    })
  }
  swiperConfig() {
    this.config = {
      observer: true,
      observeParents: true,
      mousewheel: true,
      slidesPerView: 'auto',
      speed: 700,
      injectStyles: [
        `
      .swiper-wrapper {
        padding: 30px 0;
      }
      `,
      ],
    }
  }
  getMessage(text: string) {
    switch (text) {
      case 'TEXT__TITLE':
        return this.translate.instant('STARTER_KIT_SHARED.TITLE')
      case 'TEXT__DETAIL':
        return this.translate.instant('STARTER_KIT_SHARED.DETAIL')
      case 'TEXT__CUSTOMERID':
        return this.translate.instant('STARTER_KIT_SHARED.CUSTOMERID')
      case 'TEXT__SUPPORTCODE':
        return this.translate.instant('STARTER_KIT_SHARED.SUPPORTCODE')
      case 'TEXT__DOWNLOAD':
        return this.translate.instant('STARTER_KIT_SHARED.DOWNLOAD')
      case 'TEXT__FREESIGNUP--1':
        return this.translate.instant('STARTER_KIT_SHARED.FREESIGNUP__1')
      case 'TEXT__FREESIGNUP--2':
        return this.translate.instant('STARTER_KIT_SHARED.FREESIGNUP__2')
      case 'TEXT__FREESIGNUP--3':
        return this.translate.instant('STARTER_KIT_SHARED.FREESIGNUP__3')
      default:
        return
    }
  }
}
